
/* eslint-disable import/no-anonymous-default-export */

export default {
    lang: "en",
    direction: "ltr",

    main_site: "https://www.ravmilim.com/en/",
    org_site: "https://org.ravmilim.com/en/",
    edu_site: "https://edu.ravmilim.com/en/",

    footer_social_phone_url: "tel:+972036070927",
    footer_social_instagram_url: "footer_social_instagram_url",
    footer_social_facebook_url: "https://facebook.com/ravmilim",
    footer_social_phone_text: "Phone",
    footer_social_facebook_text: "Facebook",

    keyboard_icon_title: "Keyboard",
    popup_close_icon_title: "Close popup",
    sidebar_close_icon_title: "Close menu",
    search_icon_title: "search",

    landscape_text: "<div>Rotate your phone to</div><div>portrait mode to view</div><div>the site optimally</div>",

    search: "Search",
    new_search: "New Search",
    clean: "Clean",

    sidebar_signout_button: "Sign out",

    //#region alert SignUp
    alert_signup_title: "For subscribers only",
    alert_signup_title_privet: "Your subscription has expired",
    alert_signup_content: `
        <div>Rav-Milim dictionary is available only for</div>
        <div>subscribers. Join now and enjoy the leading</div>
        <div>online Hebrew dictionary.</div>
    `,
    alert_signup_content_privet: `
        <div>Don't worry, you can easily renew it and keep</div>
        <div>enjoying Rav-Milim. Our customer service will</div>
        <div>contact you to renew your subscription.</div>
    `,
    alert_signup_subscription_button: "Subscription Renewal",
    alert_signup_log_in_button: "Log in",
    alert_signup_later_button: "Later",
    //#endregion alert SignUp

    //#region alert SignOut
    alert_signout_title: "<div>Just before we say goodbye,</div><div>are you sure you want to log out?</div>",
    alert_signout_close_button: "Want To Stay",
    alert_signout_sign_out_button: "Want To Log Out",
    //#endregion alert SignOut

    //#region cognito api errors
    cognito_api_error_NotAuthorizedException: "Incorrect email or password.",
    cognito_api_error_LimitExceededException: "Attempt limit exceeded, please try after some time.",
    cognito_api_error_CodeMismatchException: "Invalid verification code provided, please try again.",
    cognito_api_error_ExpiredCodeException: "Invalid code provided, please request a code again.",
    cognito_api_error_UserNotConfirmedException: "User is not confirmed.",
    cognito_api_error_SignUpNotAuthorizedException: "A client attempted to write unauthorized attribute",
    cognito_api_error_UsernameExistsException: "User already exists",
    cognito_api_error_ChangePasswordNotAuthorizedException: "Incorrect password.",
    cognito_api_error_CognitoOrgEmailDomainError: "You may use only an address in your organization’s domain",
    cognito_api_error_CognitoOrgNotExistError: "Invalid organization code",
    cognito_api_error_CognitoOrgExpiredError: "The organization subscription has expired",
    cognito_api_error_AliasExistsException: "An account with the given email already exists",
    cognito_api_error_InvalidParameterException: "Invalid phone number format",
    cognito_api_error_CognitoUserLimitLoginError: "For security reasons, your account access has been temporarily blocked. Please try again in a few minutes.",
    cognito_api_error_CognitoUserDailyLimitLoginError:"You have exceeded the daily limit for the number of connections, please try again later.",
    //#endregion cognito api errors

    migration_welcome_title: "Welcome to our new website!",
    migration_welcome_text: `<div>Please update your password</div><div>to meet our security standards.</div>`,
    migration_new_password_field: "New Password",
    migration_confirm_password_field: "Confirm Password",
    migration_submit_button: "Update Password",
    migration_password_mismatch_error: "Passwords do not match",
    migration_process_failed_error: "Migration failed. Please contact support or try again.",
    migration_change_password_error: "Error changing password. Please contact support.",
    migration_stuck_use_forgot_password: "We couldn't send a reset code. Please use the Forgot Password link on the login page.",
    migration_partial_success_contact_support: "Password updated successfully, but some details are missing. Please contact support.",
    migration_success_title: "All set",
    migration_success_text: "Please log in with your updated password.",
    migration_success_button: "Done",
    migration_confirm_account_text: "Please enter the verification code sent to your email",
    migration_confirm_account_button: "OK",
    migration_running_title: "Migrating your account…",
    migration_unknown_error: "An unknown error occurred.",
    migration_missing_context_error: "Missing migration details. Please log in again.",
    migration_backend_failed: "Migration failed, please contact support.",
    migration_back_to_login: "Back to login",
    migration_already_moved_message: 'It looks like you have already moved to the new website. Please click "Login" again and sign in with your new password.',
    migration_spam_warning: "Please make sure our email hasn't accidentally been sent to your spam folder.",
    migration_resend_code_link: "Didn't receive a code? Send a new code",
    migration_code_sent_confirmation: "Code sent! Check your inbox.",
    migration_confirm_code_required: "Please enter the verification code",

    // Home page banner (static, not tied to migration flow)
    home_banner_text: "That’s right – this is the new (and only) Rav-Milim website! You're absolutely in the right place. Just one more step and you're in.",
    home_banner_link_text: "Click here for login instructions >>",
    home_banner_mobile_text: "Nakdan Morfix subscribers - Log in with your existing email address and password.",
    home_banner_mobile_link_text: "Login instructions",

    login_error_invalid_credentials: "Invalid email or password",
    
    //#region FormInputField
    form_input_field_required_error: "Required field",
    form_input_field_minlength_error: "At least {0} characters",
    form_input_field_email_error: "Invalid email address",
    form_input_field_tel_error: "Invalid phone number",
    form_input_field_password_length_error: "Password must contain at least {0} characters",
    form_input_field_password_lowercase_error: "Password must contain a lower case letter",
    form_input_field_password_uppercase_error: "Password must contain an upper case letter",
    form_input_field_password_numeric_error: "Password must contain a number",
    form_input_field_password_symbol_error: "Password must contain a special character\\space",
    form_input_field_password_he_error: "Password can’t contain Hebrew letters",
    form_input_field_password_space_error: "Password must not contain a leading\\trailing space",
    //#endregion FormInputField

    //#region Login form
    login_form_title: "Log in",
    login_form_username_field: "Email",
    login_form_username_org_field: "Organizational Email",
    login_form_password_field: "Password",
    login_form_forgot_password_button: "Forgot Password?",
    login_form_login_button: "Log in",
    login_form_signup_button: "Sign Up",
    login_form_signup_with_orgcode_button: "Sign up with Organizational Passcode",
    login_form_edu_button: "התחברות דרך משרד החינוך",
    login_form_org_button: "Organization login",
    login_form_main_site_button: "Go to the General Website",
    login_form_forgot_password_title: "Password Reset",
    login_form_forgot_password_text: "Enter your Email below and we will send a message to reset your password",
    login_form_forgot_password_send_message_button: "Send",
    login_form_confirm_password_title: "Choose A new Password",
    login_form_confirm_password_text_by_email: "We have sent a password reset code by email to {0}. Enter it below to reset your password.",
    login_form_confirm_password_text_by_phone: "We have sent a password reset code by phone to {0}. Enter it below to reset your password.",
    login_form_confirm_code_field: "Code",
    login_form_confirm_new_password_field: "Password",
    login_form_confirm_new_password_field_placeholder: "Enter a password here",
    login_form_confirm_again_new_password_field: "Enter Password Again",
    login_form_confirm_again_new_password_field_placeholder: "Enter password again",
    login_form_confirm_change_password_button: "Saving And Log in",
    login_form_new_password_required_password_title: "Choose a new password",
    login_form_new_password_required_password_text: "Please update your password to meet our security standards.",
    login_form_confirm_new_password_match_error: "Passwords must match",
    verify_code_title: 'Verify Your Identity',
    verify_code_step: 'Step 1 of 2',
    verify_code_continue_button: 'Verify and Continue',
    set_new_password_title: 'Set New Password',
    set_new_password_step: 'Step 2 of 2',
    set_new_password_subtitle: 'Ensure your new password is secure and difficult to guess. Avoid using common phrases or personal info.',
    password_requirements_title: 'Password Requirements',
    password_req_min_chars: 'Minimum 8 characters',
    password_req_lowercase: 'One lowercase letter',
    password_req_uppercase: 'One uppercase letter',
    password_req_number: 'One number',
    password_req_symbol: 'One special character',
    login_form_orgcode_title: "Organizational Passcode",
    login_form_orgcode_text: "Please enter your organizational passcode below. Then sign up to our website with your organizational email address.",
    login_form_orgcode_code_field: "Organizational Passcode",
    login_form_orgcode_get_org_data_button: "Next",
    //#endregion Login form

    //#region Signup form
    signup_form_first_name_field: "First Name",
    signup_form_last_name_field: "Last Name",
    signup_form_email_field: "Email",
    signup_form_email_org_field: "Organizational Email",
    signup_form_phone_field: "Phone",
    signup_form_password_field: "Password",
    signup_form_password_field_placeholder: "At least 8 characters",
    signup_form_again_password_field: "Enter Password Again",
    signup_form_again_password_field_placeholder: "Enter password again",
    signup_form_agree_to_terms_use_text: "I agree to the",
    signup_form_terms_use_text: "terms of use.",
    signup_form_create_account_button: "Create Account",
    signup_form_create_account_org_button: "Next",
    signup_form_cancel_button: "Cancel",
    signup_form_terms_use_error: "To continue, you must agree to the terms of use.",
    signup_form_confirm_account_title: "Confirm Your Account",
    signup_form_confirm_account_by_email: "We have sent a code by email to {0}. Enter it below to confirm your account.",
    signup_form_confirm_account_by_phone: "We have sent a code by phone to {0}. Enter it below to confirm your account.",
    signup_form_confirm_account_by_email_without_address: "We have sent a code by email. Enter it below to confirm your account.",
    sms_sent_to_phone: 'We sent a code via SMS to {0}',
    sms_no_phone: 'No phone number found for this account',
    sms_otp_expired_or_invalid: 'Incorrect or expired code, please try again',
    otp_expired_or_invalid: 'Incorrect or expired code, please try again',
    sms_option_label: 'Send me an SMS instead to {0}',
    voice_option_label: 'Call me instead to {0}',
    voice_sent_to_phone: 'Calling {0}! Enter the code when you receive it.',
    voice_no_phone: 'No phone number found for this account',
    voice_rate_limited: 'Please wait a moment before requesting another call',
    signup_form_confirm_account_code_field: "Verification Code",
    signup_form_confirm_account_confirm_button: "Confirm Account",
    signup_form_confirm_account_resend_code_button: "Didn't receive a code? Send a new code",
    //#endregion Signup form

    //#region PersonalInformation form
    personalinformation_form_first_name_field: "First Name",
    personalinformation_form_last_name_field: "Last Name",
    personalinformation_form_email_field: "Email",
    personalinformation_form_email_org_field: "Organizational Email",
    personalinformation_form_phone_field: "Phone",
    personalinformation_form_save_button: "Save",
    personalinformation_form_cancel_button: "Cancel",
    personalinformation_form_success_alert_text: "Details changed successfully",
    personalinformation_form_success_alert_button: "Close",
    //#endregion PersonalInformation form

    //#region ChangePassword form
    changepassword_form_old_password_field: "Old Password",
    changepassword_form_new_password_field: "New Password",
    changepassword_form_confirm_password_field: "Confirm New Password",
    changepassword_form_confirm_new_password_match_error: "Passwords must match",
    changepassword_form_save_button: "Save",
    changepassword_form_cancel_button: "Cancel",
    changepassword_form_success_alert_text: "Password changed successfully",
    changepassword_form_success_alert_button: "Close",
    //#endregion ChangePassword form

    //#region home page
    home_page_opening_text: "A truly amazing tool for the learner of Modern Hebrew",
    sign_up_button: "Sign Up",
    log_in_button: "Log in",
    home_page_ravmilim_explainer: "https://ravmilim.activetrail.biz/ravmilim-explainer-EN",
    home_page_subscription_button: "Subscription Renewal",
    home_page_topic_1: "Rhymes",
    home_page_topic_2: "Expressions",
    home_page_topic_3: "Translation",
    home_page_topic_4: "Grammar",
    home_page_topic_5: "Numbers",
    home_page_topic_6: "Crosswords Puzzle",
    home_page_topic_7: "Synonyms",
    home_page_topic_8: "Definition",
    home_page_about_title: "About Rav-Milim",
    home_page_about_text_1: `
        <div>Use of Rav-Milim requires no former linguistic or computer knowledge. By simply typing in a word, in any form, an array of linguistic information is displayed, including the word Nikud. The dictionary includes 70,000 main entries covering all strata and styles of language, each with all of its inflectional forms, with clear explanations, sources and usage examples.</div>
    `,
    home_page_about_text_2: `
        <div>The dictionary is constantly updated, ensuring that all new words authorized by the Academy of the Hebrew Language, as well as all the latest technological and professional innovations, from a vast array of fields, will always be found in the dictionary.</div>
    `,
    home_page_customers_title: "Our Customers",
    //#endregion home page

    //#region purchase page
    purchase_page_subscription_corporate_title: "Organizational subscription",
    purchase_page_subscription_corporate_text: "For organizations with more than 10 employees. Fill in the organization details, and a customer representative will contact you.",
    purchase_page_subscription_corporate_button: "Fill In Details >",
    purchase_page_subscription_yearly_title: "Yearly Plan",
    purchase_page_subscription_yearly_price: "699<span>₪</span>",
    purchase_page_subscription_yearly_text: "One-time payment",
    purchase_page_subscription_yearly_label: "Most Popular",
    purchase_page_subscription_monthly_title: "Monthly Plan",
    purchase_page_subscription_monthly_price: "64<span>₪</span> per month",
    purchase_page_subscription_monthly_text: "Monthly recurring payment",
    purchase_page_subscription_buy_button: "Sign Up >",
    purchase_page_subscription_renew_button: "Subscription Renewal",
    purchase_page_signup_title: "Registeration",
    purchase_page_signup_org_title: "Registeration",
    purchase_page_subscription_org_title: "Registration",
    purchase_page_subscription_org_submitted_title: "<span>Nice to</span>&nbsp;<span>meet you</span>",
    purchase_page_subscription_org_submitted_sub_title: "Hello, {0}!",
    purchase_page_subscription_org_submitted_text: `
        <div>Our customer service will contact you</div>
        <div>by phone in the next few days to</div>
        <div>complete the purchase process.</div>
    `,
    purchase_page_subscription_org_submitted_home_button: "Home Page",
    //#endregion purchase page

    //#region user page
    user_page_title: "Personal Zone",
    user_page_editing_personal_details: "Editing Personal Details",
    user_page_change_password: "Change Password",
    user_page_write_to_us: "Contact us",
    user_page_signout: "Sign out",
    user_page_request_cancel_subscription: "Request To Cancel Subscription",
    user_page_purchase: "Subscription Renewal",
    cancel_subscription_button: "Cancel Subscription",
    cancellation_policy_button: "Cancellation Policy",
    //#region user page 

    //#region personal_information page
    personalinformation_page_title: "Personal Details",
    //#region personal_information page 

    //#region change_password page
    changepassword_page_title: "Change Password",
    //#region change_password page 

    //#region search page 
    page_search_title: "Word Search",
    page_search_sub_title: "Look up a word, phrase, date or number",
    word_search_input_placeholder: "Word Search",
    search_renew_banner_text: "Your subscription will expire soon",
    search_renew_banner_link: "Renew subscription",

    number_of_search_results: "{0} results were received:",
    number_of_search_1_results: "1 result was received:",
    search_results_correction_title: "No results found for the word you've entered.",
    search_results_number_correction_title: "There is no translation for the requested numerical expression.",
    search_results_exceeding_daily_searches_limit: "Exceeding daily searches limit.",
    search_results_correction_sub_title: "Did you mean:",
    search_results_correction_contact_us_1: "Missing word?",
    search_results_correction_contact_us_2: "Contact us",

    full_analyze_data_tab_hebrewExplain: "Definition",
    full_analyze_data_tab_thesaurus: "Synonyms",
    full_analyze_data_tab_idioms: "Expressions",
    full_analyze_data_tab_rhyme: "Rhymes",
    full_analyze_data_tab_translate: "Translation",
    full_analyze_data_tab_grammar: "Grammar",
    full_analyze_other_words_title: "Other results:",
    //#endregion search page

    //#region crossword page
    page_crossword_title: "Crosswords Puzzle",
    page_crossword_sub_title: "<span>Select word length and enter the word's </span><br /><span>known letters (at least one letter)</span>",

    crossword_number_of_letters: "Number of letters in requested word:",
    crossword_number_of_letters_mobile: "Letters",
    crossword_number_of_letters_option: "{0} Lettes",
    crossword_only_hebrew_letters_alert_message: "Please enter hebrew letters only",
    crossword_enter_at_least_one_letter_alert_message: "Please enter at least one letter in searched term",
    crossword_leave_at_least_one_empty_letter_alert_message: "Please leave at least one empty box in searched term",
    crossword_no_results_message: "No suitable words found",
    //#endregion crossword page

    //#region nakdan page 
    page_nakdan_title: "Nakdan",
    page_nakdan_sub_title: "The most accurate automatic text vocalizer on the web",
    nakdan_help: "Help",
    nakdan_clear_sceen: "Clear Screen",
    nakdan_decrease: "Decrease",
    nakdan_increase: "Increase",
    nakdan_Remove: "Remove",
    nakdan_submit: "Vocalization",
    nakdan_instructions: "Double-click on a word to change its vocalization.",
    nakdan_instructions_phone:"Double-click on a word to change its vocalization.",
    nakdan_help_alert_button: "Got it!",
    nakdan_header1: "Adding niqqud to a full text:",
    nakdan_header2: "Changing the vocalization of a word:",
    nakdan_Vocalization: "nakdan Vocalization",
    nakdan_Vocalizatio_content: "– Automatically add vowel diacritics to the entire text in the box.",
    nakdan_Remove_Vocalization: "Remove",
    nakdan_Remove_Vocalization_content: "– Remove all vowel diacritics from the text in the box. The non-vocalized text will be displayed in standard plene spelling.",
    nakdan_clear_screen: "Clear Screen",
    nakdan_clear_screen_content: "– Delete the entire text in the box.",
    nakdan_Increase_Text_Size: "Increase Text Size",
    nakdan_Increase_Text_Size_content: "– Increase the font size of the entire text in the box.",
    nakdan_Decrease_Text_Size: "Decrease Text Size",
    nakdan_Decrease_Text_Size_content: "– Decrease the font size of the entire text in the box.",
    nakdan_mid_text: "To add vowel diacritics to a single word or to change its diacritics, double-click on that word. Two options will then show:",
    nakdan_mid_text_phone: "To add vowel diacritics to a single word or to change its diacritics, double-click on that word. Two options will then show:",
    nakden_choose_word: "Choose another option",
    nakden_choose_word_contnt: "– Select the required vocalization from the list More options displayed in the window below the text. Clicking on 'Replace' will replace the automatic vocalization of the highlighted word with the one selected. Alternatively, you can double-click on the preferred word to use it in place of the highlighted word in the text.",
    nakden_choose_word_contnt_phone: "– Select the required vocalization from the list More options displayed in the window below the text. Clicking on Save will replace the automatic vocalization of the highlighted word with the one selected.",
    nakdan_Manual_Vocalization: "Manual Vocalization",
    nakdan_Manual_Vocalization_content:"– Add vowel diacritics manually to a word (or part of it). Choose the appropriate diacritic to any of the letters in the word. Click 'Replace' to substitute the automatic vocalization with the one selected manually.",
    nakdan_Manual_Vocalization_content_phone: "– Add vowel diacritics manually to a word (or part of it). Choose the appropriate diacritic to any of the letters in the word. Click Save to substitute the automatic vocalization with the one selected manually.",
    nakdan_close:"Close",
    nakdan_close_content:" – Hide the vocalization changing window and return to the main text box.",
    nakdan_save:"Save",
    nakdan_cancel:"Cancel",
    nakdan_replace: "Replace",
    nakdan_More_options: "More options:",
    nakdan_Manual_Vocalization_extended: "Manual vocalization:",
    //#endregion nakdan page 

    melingo_address: "16 Tozeret Haaretz, Tel Aviv",
    melingo_phone: "03-6070927",
    alert_temp_block_title:"Your subscription doesn’t include this feature.",
    alert_temp_block_content: "You can update your subscription and get access to the entire website.",
    alert_temp_block_button:"got it",
    billing_loading: "Loading purchase…",
    billing_failed_head: "nfortunately, the purchase failed. You dont have access to this feature.",
    billing_failed_sub_button_again: "Retry",
    billing_failed_sub_button_contact: "Contact Us",
    billing_invalid_credit_card_details: "Invalid credit card details",
    billing_invalid_credit_card_details_content_1: "Please try again.",
    billing_invalid_credit_card_details_content_2: "If the problem persists, please contact our customer support.",
    billing_failed_title: "Something Went Wrong",
    billing_failed_content_1: "Unfortunately, the purchase failed.",
    billing_failed_content_2: "Please contact our customer support to complete it.",
    login_form_edu_school_not_registered: 'Your school is not registered with Rav-Milim. Please contact your administrator.',
    login_form_edu_unexpected_error: 'An error occurred during login. Please try again.',

};
